import { type JSX, useState } from "react";
import styled from "styled-components";
import { useMutation } from "urql";
import AiInput from "../../shared/components/ai/AiInput";
import AiThread from "../../shared/components/ai/AiThread";
import RenderMark from "../../shared/components/RenderMark";
import type { AiMessageRoleType, AiMessageType } from "../../shared/types";
import { continueMutation } from "./queries";

interface IProps {
    id: string;
    threadItems: {
        id: string;
        type: AiMessageType;
        role: AiMessageRoleType | null;
        content: string;
    }[];
    chatbot: {
        id: string;
        name: string;
        description: string;
    };
}

const Container = styled.div`
    max-width: 100ch;
    margin: 0 auto;
`;

function Thread({ id, threadItems, chatbot }: IProps): JSX.Element {
    const [contninueResult, executeContinue] = useMutation(continueMutation);
    const [items, setItems] = useState(threadItems);
    const [qItem, setQItem] = useState("");

    const continueThread = async (content: string) => {
        if (contninueResult.fetching) {
            return;
        }
        if (!content) {
            return;
        }
        setQItem(content);
        const result = await executeContinue({ id, content });
        if (result.error || result.data.standaloneAiThreadContinue?.error) {
            console.error(result.error || result.data.standaloneAiThreadContinue?.error);
        } else {
            setItems(result.data.standaloneAiThreadContinue.standaloneAiThread.aiThreadItems);
            setQItem("");
        }
    };

    return (
        <>
            <h2>{chatbot.name}</h2>
            <Container>
                <RenderMark content={chatbot.description} unsafe />
                <AiThread messages={items} fmtUser={false} />
                {qItem && (
                    <AiThread
                        messages={[{ id: "q", type: "message" as AiMessageType, role: "user", content: qItem }]}
                        fmtUser={false}
                    />
                )}
                <AiInput onSubmit={continueThread} loading={contninueResult.fetching} />
            </Container>
        </>
    );
}

export default Thread;
